<template>
  <div>
    <highcharts :options="BoxPlot()"></highcharts>
  </div>
</template>

<script>
export default {
  props: ["title", "data"],
  methods: {
    BoxPlot() {
      let chart = {
        chart: {
          type: "boxplot",
          style: {
            fontFamily: "Mitr",
          },
        },

        title: this.data.title,
        subtitle: this.data.subtitle,

        legend: {
          useHTML: true,
          enabled: false,
        },

        xAxis: {
          labels: { useHTML: true },
          categories: this.data.daterange,
          title: {
            text: "Date",
          },
        },

        yAxis: {
          useHTML: true,
          title: {
            text: "Number",
          },
          plotLines: [
            {
              value: 932,
              color: "red",
              width: 1,
              label: {
                text: "",
                align: "center",
                style: {
                  color: "gray",
                },
              },
            },
          ],
        },
        series: [
          {
            name: "Summary",
            data: this.data.data,
            tooltip: {
              headerFormat: "<em>Date: {point.key}</em><br/>",
            },
          },
        ],
      };
      return chart;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>